import { Mountain } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LIFT_PRESETS } from "../lib/specs";
import { useVehicle } from "../context/VehicleContext";

export const LiftSelector = () => {
  const { lift, setLift } = useVehicle();
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="lift-selector">
      <span className="flex items-center gap-1 font-mono text-[10px] text-slate-500 tracking-widest uppercase">
        <Mountain size={12} className="text-amber" /> {t("lift.suspension")}
      </span>
      <div className="inline-flex flex-wrap rounded-lg bg-ink border border-steel p-0.5 gap-0.5">
        {Object.keys(LIFT_PRESETS).map((k) => (
          <button key={k} data-testid={`lift-${k}`} onClick={() => setLift(k)}
            className={`px-2.5 py-1 rounded-md font-mono text-[10px] uppercase tracking-widest transition-colors ${
              lift === k ? "bg-amber text-ink font-bold" : "text-slate-400 hover:text-white"
            }`}>
            {t(`lift.${k}`)}
          </button>
        ))}
      </div>
      {lift !== "stock" && (
        <span className="font-mono text-[9px] text-amber/80 tracking-wide">{t("lift.adjusted")}</span>
      )}
    </div>
  );
};
